module.exports = "/static/media/lineto-circular-black.99406e69.woff";